// Quran-text utility helpers (Arabic letter handling).

// Combining-mark range used by classical Arabic Quranic orthography.
const ARABIC_MARK_RE = /[\u064B-\u065F\u0670\u06D6-\u06ED]/u;
const WS_RE = /[\s\ufeff]/u;

// Letters of the Bismillah (no diacritics). Combining marks may interleave
// these letters in different orders depending on data source, so we walk
// char-by-char and accept any marks/whitespace between target letters.
const BISMILLAH_LETTERS = "بسمٱللهٱلرحمنٱلرحيم";

/**
 * Strip a leading Bismillah from an Arabic verse text.
 * Returns the text unchanged if the prefix is not a Bismillah.
 * Handles diacritic-order variations across data sources (e.g. al-quran.cloud).
 */
export function stripBismillah(text) {
  if (!text) return text;
  let i = 0;
  while (i < text.length && WS_RE.test(text[i])) i++;
  let ti = 0;
  while (i < text.length && ti < BISMILLAH_LETTERS.length) {
    const c = text[i];
    if (c === BISMILLAH_LETTERS[ti]) {
      ti++;
      i++;
    } else if (ARABIC_MARK_RE.test(c) || WS_RE.test(c)) {
      i++;
    } else {
      return text;
    }
  }
  if (ti < BISMILLAH_LETTERS.length) return text;
  while (
    i < text.length &&
    (ARABIC_MARK_RE.test(text[i]) || WS_RE.test(text[i]))
  ) {
    i++;
  }
  return text.slice(i);
}

/**
 * Legacy heuristic Bismillah-prefix remover used by the Surah-mode flow:
 * returns null when the verse IS the entire Bismillah (so it can be
 * filtered out and replaced by an ornamental header).
 */
export const removeBismillahPrefix = (text) => {
  if (!text) return text;
  const trimmed = text.trim();
  const startsWithBism =
    trimmed.startsWith("بِسْمِ") || trimmed.startsWith("بسم");
  if (startsWithBism && trimmed.length > 40) {
    for (let i = 35; i < 45; i++) {
      if (trimmed[i] === " " && i > 30) {
        const afterBismillah = trimmed.substring(i + 1).trim();
        if (afterBismillah.length > 0) return afterBismillah;
      }
    }
  }
  if (startsWithBism && trimmed.length <= 45) return null;
  return text;
};
